import { Injectable } from '@angular/core';
import { Payment } from 'src/app/models/payment';
import { BaseCardService } from '../base-card.service';
import { InvoiceService } from '../invoice/invoice.service';
import { LocationService } from '../location/location.service';
import { TransactionService } from '../transaction/transaction.service';

@Injectable({
  providedIn: 'root',
})
export class GiftCardService extends BaseCardService {
  constructor(
    protected invoiceService: InvoiceService,
    protected locationService: LocationService,
    protected transactionService: TransactionService
  ) {
    super(invoiceService, locationService, transactionService);
  }

  public getInitialPayment = (amount: string): Payment => {
    return new Payment({
      RequestedAmount: amount,
      transactionId:  this.invoiceService.login.transactionId,
      CountryCode: this.locationService.location.countryCode,
      PaymentReference: '',
      PaymentTypeId: 100006,
      CardPIN: '',
    });
  };
}
